import React from 'react';
import './SolutionSection.css';

const SolutionSection = () => {
    return (
        <div id="solution" className="solution-section">
            <h2 className="solution-title">A One-Stop AI-Powered Platform</h2>
            <div className="solution-image-container">
                <img src="/Need.png" alt="Need Illustration" className="need-image" />
            </div>
            <div className="solution-description-box">
                <p className="solution-description">
                    UniVerse provides a comprehensive solution to the problems faced by educational institutions.
                    With AI-powered tools and a centralized platform, we streamline academic processes and enhance
                    the learning experience.
                </p>
            </div>
        </div>
    );
};

export default SolutionSection;